module.exports = __webpack_public_path__ + "static/media/curry_jersey.25cb7de9.jpg";